// @flow
import * as React from 'react';
import {Link} from 'react-router-dom';
import {PropTypes} from 'prop-types';
import {Grid, makeStyles, Typography} from '@material-ui/core';

import uploadProduct from '../../../../assets/img/steps/upload-product.svg';

import CustomModal from '../../../../elements/CustomModal/CustomModal';
import {colors} from '../../../../assets/styles/colors';
import uploadDesktop from '../../../../assets/img/upload-desktop.svg';
import uploadIg from '../../../../assets/img/upload-ig.svg';

type Props = {|
  open: boolean,
  handleCloseModal: () => void,
|};

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(4, 4, 1, 4),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(4, 0, 1, 0),
    },
    maxWidth: 440,
  },
  title: {
    textAlign: 'center',
    fontWeight: 600,
    fontSize: 24,
  },
  subtitle: {
    textAlign: 'center',
    marginTop: theme.spacing(1),
    color: '#3A3A49',
  },
  content: {
    marginTop: theme.spacing(2),
    borderRadius: '12px',
    paddingBottom: theme.spacing(2),
    maxWidth: 440,
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  imgUploadProduct: {
    width: '5rem',
    margin: '0.5rem auto',
  },
  boldText: {
    fontWeight: 700,
  },
  titleOption: {
    textAlign: 'center',
    color: colors.grey1000,
    fontWeight: 700,
    fontSize: 12,
    margin: theme.spacing(2, 0),
  },
  cardOption: {
    height: '100%',
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    background: '#FFFFFF',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(39, 53, 245, 0.16)',
    borderRadius: '12px',
  },
  containerImg: {
    maxWidth: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  description: {
    textAlign: 'center',
    color: colors.grey700,
    fontSize: 12,
  },
  linkBtn: {
    textDecoration: 'none',
    maxWidth: '100%',
  },
}));

export function UploadProductModal(props: Props) {
  const {open, handleCloseModal} = props;

  const classes = useStyles();

  return (
    <CustomModal open={open} handleCloseModal={handleCloseModal}>
      <div className={classes.root}>
        <img
          src={uploadProduct}
          alt="upload your first product"
          className={classes.imgUploadProduct}
        />
        <Typography className={classes.title}>
          ¡Súper! Vamos a subir tu primer producto
        </Typography>
        <Typography className={classes.subtitle}>
          Tienes dos opciones de donde subir la foto del producto.
        </Typography>
        <div className={classes.content}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Link
                to="/products/new?fromOnboarding=true"
                className={classes.linkBtn}
              >
                <div className={classes.cardOption}>
                  <div className={classes.containerImg}>
                    <img src={uploadDesktop} alt="upload using desktop" />
                    <Typography className={classes.titleOption}>
                      Sube fotos desde este dispositivo
                    </Typography>
                    <Typography className={classes.description}>
                      Debes tener las imágenes almacenadas en este dispositivo.
                    </Typography>
                  </div>
                </div>
              </Link>
            </Grid>
            <Grid item xs={6}>
              <Link
                to="/products?instagramUpload=1&fromOnboarding=1"
                className={classes.linkBtn}
              >
                <div className={classes.cardOption}>
                  <div className={classes.containerImg}>
                    <img src={uploadIg} alt="upload using ig" />
                    <div>
                      <Typography className={classes.titleOption}>
                        Sube fotos desde Instagram
                      </Typography>
                    </div>
                    <div>
                      <Typography className={classes.description}>
                        Debes asegurarte de tener abierta la cuenta de Instagram
                        de tu negocio.
                      </Typography>
                    </div>
                  </div>
                </div>
              </Link>
            </Grid>
          </Grid>
        </div>
      </div>
    </CustomModal>
  );
}

UploadProductModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
};
